import Dropdown from "common/Dropdown/Dropdown";
import React from "react";
import styled, { useTheme } from "styled-components";
import EllipsisOutlined from "@ant-design/icons/EllipsisOutlined";
import { BacktestingRunType, BotType, LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { openMessage } from "utils/misc";
import useBacktestingActions from "features/bots/BotForm/Backtesting/common/useBacktestingActions";
import ActionsTrigger from "features/bots/BotForm/Backtesting/NewLook/ActionsTrigger";

interface BacktestingActionsProps {
  backtestingRun: BacktestingRunType;
  openDeleteModal: () => void;
  botType: BotType;
}

const BacktestingActions = ({
  backtestingRun,
  openDeleteModal,
  botType,
}: BacktestingActionsProps) => {
  const { menuItems } = useBacktestingActions({
    data: backtestingRun,
    openDeleteModal,
    openMessage,
    botType,
  });
  const { isNewLook } = useTheme();
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);

  if (isNewLook) {
    // A real button, so the row's Enter key doesn't open the results.
    return (
      <NewLookActions
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
          <ActionsTrigger label={t("backtesting.actions.backtest_actions")} />
        </Dropdown>
      </NewLookActions>
    );
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
        <StyledEllipsisOutlined />
      </Dropdown>
    </div>
  );
};

export default BacktestingActions;

const StyledEllipsisOutlined = styled(EllipsisOutlined)`
  cursor: pointer;
  font-size: 24px;
  margin-left: 12px;
  color: ${(p) => p.theme.colors.basic};
  transform: rotate(90deg);
`;
const NewLookActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;
